import React from 'react';

const InstructionVisibilityContext = React.createContext(false);

export default InstructionVisibilityContext;



// WEBPACK FOOTER //
// ./src/view/fullScreenWorkout/InstructionVisibilityContext.js